let TechSpaceErrorType = /* @__PURE__ */ function(TechSpaceErrorType$1) {
	TechSpaceErrorType$1["Size"] = "Size";
	TechSpaceErrorType$1["NoSpaceLeft"] = "NoSpaceLeft";
	TechSpaceErrorType$1["NoQuantityInfo"] = "NoQuantityInfo";
	TechSpaceErrorType$1["NoLevelInfo"] = "NoLevelInfo";
	TechSpaceErrorType$1["NotImplementedProperty"] = "NotImplementedProperty";
	TechSpaceErrorType$1["NoLocationInfo"] = "NoLocationInfo";
	TechSpaceErrorType$1["ZeroQuantityNeeded"] = "ZeroQuantityNeeded";
	TechSpaceErrorType$1["Unknown"] = "Unknown";
	return TechSpaceErrorType$1;
}({});
export { TechSpaceErrorType };

//# sourceMappingURL=index98.js.map